"use strict";

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageCache = void 0;

var utils_1 = require("./utils");

var MessageCache = /*#__PURE__*/function () {
  /**
   * @param {Number} gossip
   * @param {Number} history
   * @param {msgIdFn} msgIdFn a function that returns message id from a message
   *
   * @constructor
   */
  function MessageCache(gossip, history, msgIdFn) {
    _classCallCheck(this, MessageCache);

    /**
     * @type {Map<string, RPC.Message>}
     */
    this.msgs = new Map();
    this.peertx = new Map();
    /**
     * @type {Array<Array<CacheEntry>>}
     */

    this.history = [];

    for (var i = 0; i < history; i++) {
      this.history[i] = [];
    }
    /**
     * @type {Number}
     */


    this.gossip = gossip;
    /**
     * @type {Function}
     */

    this.msgIdFn = msgIdFn;
  }
  /**
   * Adds a message to the current window and the cache
   *
   * @param {RPC.Message} msg
   * @returns {Promise<void>}
   */


  _createClass(MessageCache, [{
    key: "put",
    value: function put(msg) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var msgID, msgIdStr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getMsgId(msg);

              case 2:
                msgID = _context.sent;
                msgIdStr = utils_1.messageIdToString(msgID);
                this.msgs.set(msgIdStr, msg);
                this.history[0].push({
                  msgID: msgID,
                  topics: msg.topicIDs
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Get message id of message.
     * @param {RPC.Message} msg
     * @returns {Promise<Uint8Array> | Uint8Array}
     */

  }, {
    key: "getMsgId",
    value: function getMsgId(msg) {
      return this.msgIdFn(msg);
    }
    /**
     * Retrieves a message from the cache by its ID, if it is still present
     *
     * @param {Uint8Array} msgID
     * @returns {Message}
     */

  }, {
    key: "get",
    value: function get(msgID) {
      return this.msgs.get(utils_1.messageIdToString(msgID));
    }
    /**
     * Retrieves a message from the cache by its ID, if it is present
     * for a specific peer.
     * Returns the message and the number of times the peer has requested the message
     *
     * @param {string} msgID
     * @param {string} p
     * @returns {[InMessage | undefined, number]}
     */

  }, {
    key: "getForPeer",
    value: function getForPeer(msgID, p) {
      var msgIdStr = utils_1.messageIdToString(msgID);
      var msg = this.msgs.get(msgIdStr);

      if (!msg) {
        return [undefined, 0];
      }

      var peertx = this.peertx.get(msgIdStr);

      if (!peertx) {
        peertx = new Map();
        this.peertx.set(msgIdStr, peertx);
      }

      var count = (peertx.get(p) || 0) + 1;
      peertx.set(p, count);
      return [msg, count];
    }
    /**
     * Retrieves a list of message IDs for a given topic
     *
     * @param {String} topic
     *
     * @returns {Array<Uint8Array>}
     */

  }, {
    key: "getGossipIDs",
    value: function getGossipIDs(topic) {
      var msgIDs = [];

      for (var i = 0; i < this.gossip; i++) {
        this.history[i].forEach(function (entry) {
          var _iterator = _createForOfIteratorHelper(entry.topics),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var t = _step.value;

              if (t === topic) {
                msgIDs.push(entry.msgID);
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      }

      return msgIDs;
    }
    /**
     * Shifts the current window, discarding messages older than this.history.length of the cache
     *
     * @returns {void}
     */

  }, {
    key: "shift",
    value: function shift() {
      var _this = this;

      var last = this.history[this.history.length - 1];
      last.forEach(function (entry) {
        var msgIdStr = utils_1.messageIdToString(entry.msgID);

        _this.msgs.delete(msgIdStr);

        _this.peertx.delete(msgIdStr);
      });
      this.history.pop();
      this.history.unshift([]);
    }
  }]);

  return MessageCache;
}();

exports.MessageCache = MessageCache;